export enum TopListColumnProperties {
  CURRENCY = 'currency',
  END_ACTION_TIME = 'endActionTime',
  GAME_NAME = 'gameName',
  PLAYER_EMAIL = 'playerEmail',
  PLAYER_ID = 'playerId',
  ROUND_ID = 'roundId',
  STAKE_AMOUNT = 'stakeAmount',
  TAG_LIST = 'tagList',
  WIN_AMOUNT = 'winAmount',
  GGR_AMOUNT = 'ggrAmount',
  NGR_AMOUNT = 'ngrAmount',
  RTP_PERCENT = 'rtpPercent',
}
